import React from "react";

function Description(props){
    return <p>{props.description}</p>
};

export default Description;